/**
 * 微信相关工具函数
 */

// 检查是否在微信浏览器中
export function isWechatBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

// 检查是否已有openid
export function hasOpenid() {
  return !!localStorage.getItem('wx_openid')
}

// 获取缓存的openid
export function getCachedOpenid() {
  return localStorage.getItem('wx_openid')
}

// 清除openid缓存
export function clearOpenid() {
  localStorage.removeItem('wx_openid')
}

// 安全地调用微信支付
export function safeWechatPay(payParams) {
  return new Promise((resolve, reject) => {
    if (typeof WeixinJSBridge === 'undefined') {
      // 等待微信JSBridge加载
      const timer = setTimeout(() => {
        reject(new Error('微信支付环境未准备好，请刷新页面重试'))
      }, 3000)
      
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', () => {
          clearTimeout(timer)
          invokeWechatPay(payParams, resolve, reject)
        }, false)
      }
    } else {
      invokeWechatPay(payParams, resolve, reject)
    }
  })
}

// 实际调用微信支付
function invokeWechatPay(payParams, resolve, reject) {
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    {
      appId: payParams.appId,
      timeStamp: payParams.timeStamp,
      nonceStr: payParams.nonceStr,
      package: payParams.packageValue,
      signType: payParams.signType,
      paySign: payParams.paySign
    },
    (res) => {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        resolve()
      } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        reject(new Error('用户取消支付'))
      } else {
        reject(new Error('支付失败: ' + res.err_msg))
      }
    }
  )
}